var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSampleLogo64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9991 21.8652H52.1992V31.9985H64.9991V21.8652ZM65.0018 32.3141C64.8325 49.8418 50.5713 63.9984 33.0036 63.9984C32.825 63.9984 32.6467 63.997 32.4688 63.994V51.1902C32.6467 51.195 32.8253 51.1975 33.0045 51.1975C43.6078 51.1975 52.2036 42.6022 52.2043 31.999H65.0018V32.3141ZM1 51.1973H32.4664V63.9971H1V51.1973Z",
    fill: "url(#paint0_linear_15200_158261)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.535 0H65.0014V12.7999H33.535V0ZM0.998047 31.6849C1.16729 14.1572 15.4285 0.000599232 32.9962 0.000600768C33.1749 0.000600784 33.3531 0.00206374 33.5311 0.00498009L33.5311 12.8089C33.3531 12.804 33.1745 12.8015 32.9953 12.8015C22.392 12.8015 13.7962 21.3969 13.7955 32L13.7997 32V42.1332H0.999828V32L0.998047 32V31.6849Z",
    fill: "url(#paint1_linear_15200_158261)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8672 32.0004C22.8672 26.404 27.404 21.8672 33.0004 21.8672C38.5969 21.8672 43.1337 26.404 43.1337 32.0004C43.1337 37.5969 38.5969 42.1337 33.0004 42.1337C27.404 42.1337 22.8672 37.5969 22.8672 32.0004Z",
    fill: "url(#paint2_linear_15200_158261)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15200_158261",
    x1: 33.0009,
    y1: 21.8652,
    x2: 33.0009,
    y2: 63.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EDB",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15200_158261",
    x1: 32.9997,
    y1: 0,
    x2: 32.9997,
    y2: 42.1332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EDB",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15200_158261",
    x1: 33.0004,
    y1: 21.8672,
    x2: 33.0004,
    y2: 42.1337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#407EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407EDB",
    stopOpacity: 0.8
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleLogo64);
export default __webpack_public_path__ + "static/media/sample_logo_64.0b609a5a3d45a827cf9c48157589b3c4.svg";
export { ForwardRef as ReactComponent };